import React from 'react';
import PropTypes from "prop-types";
import ListingPagesInfo from "../../listing/js/ListingPagesInfo";

const searchTypesLabels = {
    LotNumber: 'lot number',
    Postcode: 'postcode',
    County: 'country',
    Town: 'town',
    Address: 'address'
};

export default class LotSearchInfo extends React.PureComponent {

    getLabelByType(type) {
        return (type in searchTypesLabels) ? searchTypesLabels[type] : null;
    }

    renderQueryType() {
        if (this.props.queryType) {
            let label = this.getLabelByType(this.props.queryType);
            if (label) {
                return (
                    <span className="lots-search__query-type">
                        (search by: {label}
                        <button onClick={this.props.onQueryTypeClear}
                                className="lots-search__query-type-clear-button"
                                type="button"
                                title="Search by everything">
                            <svg className="icon" width="10" height="10">
                                <use xlinkHref="#icon-cross"></use>
                            </svg>
                        </button>)
                    </span>
                );
            }
        }
        return null;
    }

    render() {
        return (
            <div className="lots-search__info">
                {this.props.query ? (
                        <span className="lots-search__query-info">
                            results for
                            <span className="lots-search__query-text"> {this.props.query}</span>
                            {this.renderQueryType()},
                        </span>
                    )
                    : null
                }
                <ListingPagesInfo itemsCount={this.props.items.length} pagination={this.props.pagination}/>
            </div>
        );
    }
}

LotSearchInfo.propTypes = {
    items: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    query: PropTypes.string.isRequired,
    queryType: PropTypes.string.isRequired,
    onQueryTypeClear: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./app/components/lots-search/js/LotSearchInfo.js